import { useLayoutEffect } from 'react';
import { useLocation } from '@/util/react-router-dom';

export function ScrollToTop() {
  const location = useLocation();
  useLayoutEffect(() => {
    document.documentElement.scrollTo(0, 0);
  }, [location.pathname]);
  return null;
}
